import { render, staticRenderFns } from "./workOrder-info.vue?vue&type=template&id=65fa40fc&scoped=true&"
import script from "./workOrder-info.vue?vue&type=script&lang=js&"
export * from "./workOrder-info.vue?vue&type=script&lang=js&"
import style0 from "./workOrder-info.vue?vue&type=style&index=0&id=65fa40fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa40fc",
  null
  
)

export default component.exports